import React, { useState, useEffect } from 'react';
import { Tab, Nav } from 'react-bootstrap';

import apiClient, { downloadFile, getUserInfo } from '../../../services/apiClient';
import { GroupsList } from './components/KindergartenGroups';
import RequestsQueueFull from './components/QueueFull';

import ApplicationModal from './components/ApplicationCard/ApplicationModal';

import MediaGalleryPublic from './components/MediaGallery/MediaGalleryPublic';
import TeamPublic from './components/Team/TeamPublic';
import NewsPublic from './components/News/NewsPublic';

import './KindergartenDocs.css';
import './components/KindergartenGroups/GroupsComponents.css';


const types_print_docs_kg = [
  { keys: ['statut', 'Статут'], value: 'Статут закладу' },
  { keys: ['application'],      value: 'Зразки заяв'    },
  { keys: ['other'],            value: 'Інші документи' },
];

const getPeriod = ()=>{
  const [year, month] = (new Date().toISOString()).split("T")[0].split("-");
  if(month > 8) return +year;
  return +year - 1; 
}


const user_role = getUserInfo("role");

const checkModerator = ()=>{
  const role = user_role;
  if(!role) return false;
  return ['admin', 'moderator', 'specialist'].includes(role);
}

const isModerator = checkModerator();




/* ── SVG icons ─────────────────────────────────────────────── */

const IconFolder = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
    fill="currentColor" viewBox="0 0 16 16">
    <path d="M.54 3.87.5 3a2 2 0 0 1 2-2h3.19a2 2 0 0 1 1.45.63l.43.47H14a2
      2 0 0 1 2 2v8.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-1.99zm3.96-1.5H2.5a1
      1 0 0 0-1 .99l.04.87.62-1.11A1 1 0 0 1 3 2h1.5z"/>
  </svg>
);

const IconFile = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22"
    fill="currentColor" viewBox="0 0 16 16">
    <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3
      0A1.5 1.5 0 0 1 9.5 3V1L14 4.5zM4.5 8a.5.5 0 0 0 0 1h7a.5.5 0 0
      0 0-1zm0 2.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0
      0 1h4a.5.5 0 0 0 0-1z"/>
  </svg>
);

const IconDownload = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13"
    fill="currentColor" viewBox="0 0 16 16">
    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0
      1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5
      0 0 1 .5-.5"/>
    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5
      10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z"/>
  </svg>
);

const IconEmpty = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"
    fill="currentColor" viewBox="0 0 16 16">
    <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1
      1 0 0 0 13.707 4zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1M11 8H5a.5.5 0 0
      1 0-1h6a.5.5 0 0 1 0 1m0 2H5a.5.5 0 0 1 0-1h6a.5.5 0 0 1 0 1m0
      2H5a.5.5 0 0 1 0-1h6a.5.5 0 0 1 0 1"/>
  </svg>
);


/* ── Single document category section ──────────────────────── */

const DocsCategorySection = ({ title, docs }) => {
  const handleDownload = (doc) => {
    downloadFile(doc.url, doc.name);
  };

  if(docs.length === 0) return null;

  return (
    <div className="kg-docs-section">
      {/* Category header */}
      <div className="kg-docs-category-header">
        <div className="kg-docs-category-icon">
          <IconFolder />
        </div>
        <h6 className="kg-docs-category-title">{title}</h6>
        {docs.length > 0 && (
          <span className="badge bg-primary ms-auto">{docs.length}</span>
        )}
      </div>

      {/* Tiles or empty state */}
      {docs.length === 0 ? (
        <div className="kg-docs-empty">
          <IconEmpty />
          <span>Документів немає</span>
        </div>
      ) : (
        <div className="kg-docs-grid">
          {docs.map((doc, idx) => (
            <div
              key={idx}
              className="kg-doc-tile"
              role="button"
              tabIndex={0}
              onClick={() => handleDownload(doc)}
              onKeyDown={(e) => e.key === 'Enter' && handleDownload(doc)}
              title={`${doc.name} — ${doc.file_name}`}
            >
              <div className="kg-doc-tile-icon">
                <IconFile />
              </div>

              <p className="kg-doc-tile-name">{doc.name}</p>
              <p className="kg-doc-tile-filename">{doc.file_name}</p>

              <div className="kg-doc-tile-download">
                <IconDownload />
                Завантажити
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};


/* ── Documents tab — builds doc list and renders sections ───── */

const KindergartensDocsTabs = ({ docs, types }) => {
  const buildDocs = (key) => {
    const result = [];
    docs
      .filter((d) => d.type == key)
      .forEach((doc) => {
        const { _id, name, files } = doc;
        files
          .filter((f) => f.status?.active)
          .filter((f) => f.is_public)
          .filter((f) => new Date(f.status.start) < new Date())
          .forEach((file) => {
            result.push({
              url: `docfile?doc_id=${_id}&file_id=${file._id}`,
              name,
              file_name: file.name,
            });
          });
      });
    return result;
  };



  return (
    <div className="pt-3">
      {types.map((type_d) => (
        <DocsCategorySection
          key={type_d}
          title={type_d}
          docs={buildDocs(type_d)}
        />
      ))}
    </div>
  );
};


/* ── Стилі для горизонтальної прокрутки табів на мобільному ──── */

let TABS_STYLES_INJECTED = false;
function injectTabsScrollStyles() {
  if (TABS_STYLES_INJECTED) return;
  TABS_STYLES_INJECTED = true;
  const s = document.createElement('style');
  s.textContent = [
    '.kindergarten-tabs {',
    '  flex-wrap: nowrap;',
    '  overflow-x: auto;',
    '  overflow-y: hidden;',
    '  -webkit-overflow-scrolling: touch;',
    '  scrollbar-width: none;',
    '}',
    '.kindergarten-tabs::-webkit-scrollbar { display: none; }',
    '.kindergarten-tabs .nav-item { flex-shrink: 0; }',
    '.kindergarten-tabs .nav-link { white-space: nowrap; }',
  ].join('\n');
  document.head.appendChild(s);
}

/* ── Main component ─────────────────────────────────────────── */

const KindergartenMainInfo = ({ kindergartenData }) => {
  const [activeTab, setActiveTab] = useState('about');
  const [docs, setDocs]           = useState([]);
  const [typesDocs, setTypesDocs] = useState([]);

  const [hasGallery, setHasGallery] = useState(false);
  const [hasTeam, setHasTeam]       = useState(false);
  const [hasNews, setHasNews]       = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [requestSelectedId, setSelectedId] = useState(null);

  useEffect(() => {
    injectTabsScrollStyles();
    const getDocs = async () => {
      const url  = `kg_docfile_info?kg_id=${kindergartenData._id}`;
      const data = await apiClient.get(url);
      setDocs(data.data);
    };
    const getTypesDocs = async () => {
      const url = `/references/document-types?status=active`;
      const response = await apiClient.get(url);
      if (response.data.success) setTypesDocs(response.data.data.map(r => r.name));
    };
    const checkGallery = async () => {
      try {
        const r = await apiClient.get(`public/kg_albums?kg_id=${kindergartenData._id}`);
        const list = r.data || r || [];
        setHasGallery(Array.isArray(list) ? list.length > 0 : false);
      } catch(e) { setHasGallery(false); }
    };
    const checkTeam = async () => {
      try {
        const r = await apiClient.get(`public/employees/${kindergartenData._id}/team`);
        const list = r.data || r || [];
        setHasTeam(Array.isArray(list) ? list.length > 0 : false);
      } catch(e) { setHasTeam(false); }
    };
    const checkNews = async () => {
      try {
        const r = await apiClient.get(`public/news/kg/${kindergartenData._id}?limit=1`);
        const total = (r.data && r.data.total) || 0;
        setHasNews(total > 0);
      } catch(e) { setHasNews(false); }
    };

    getDocs();
    getTypesDocs();
    checkGallery();
    checkTeam();
    checkNews();
  }, []);

  const detailInfo = (id)=>{
    if(!id) return;
    setSelectedId(id);
    setIsModalOpen(true);
  }

  return (
    <>
    <ApplicationModal
                isOpen={isModalOpen && requestSelectedId}
                onClose={() => { setSelectedId(null) ;setIsModalOpen(false)}}
                applicationId={requestSelectedId}
                userRole={user_role}
            />
    <Tab.Container
      id="kindergarten-tabs"
      activeKey={activeTab}
      onSelect={(k) => setActiveTab(k)}
    >
      <Nav variant="tabs" className="kindergarten-tabs">
        <Nav.Item>
          <Nav.Link eventKey="about">Опис садочку</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="groups">Групи</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="documents">Заяви</Nav.Link>
        </Nav.Item>
       {hasGallery && (
        <Nav.Item>
          <Nav.Link eventKey="gallery">Галерея</Nav.Link>
        </Nav.Item>
       )}
        {hasTeam && (
        <Nav.Item>
          <Nav.Link eventKey="team">Команда</Nav.Link>
        </Nav.Item>
        )}
        {hasNews && (
        <Nav.Item>
          <Nav.Link eventKey="news">Новини</Nav.Link>
        </Nav.Item>
        )}
        <Nav.Item>
          <Nav.Link eventKey="documents_pdf">Документи закладу</Nav.Link>
        </Nav.Item>
      </Nav>

      <Tab.Content>
        <Tab.Pane eventKey="about">
          <div className="kindergarten-description">
            <p><pre style={{
              whiteSpace: 'pre-wrap', 
              wordWrap: 'break-word', 
              fontFamily: 'var(--bs-body-font-family)',
              color: 'black'
              }}>
            {kindergartenData.description}
            </pre></p>
          </div>
        </Tab.Pane>

        <Tab.Pane eventKey="groups">
          <div className="groups-content">
            <GroupsList
              groups={kindergartenData.groups}
              id={kindergartenData._id}
              mode="view"
            />
          </div>
        </Tab.Pane>

        <Tab.Pane eventKey="documents">
          <div className="documents-content">
            <RequestsQueueFull kg_id={kindergartenData._id} period={getPeriod()} isModerator={isModerator}  detailInfo={detailInfo} />
          </div>
        </Tab.Pane>

        <Tab.Pane eventKey="gallery">
          <div className="documents-content">
            <MediaGalleryPublic kgId={kindergartenData._id} groups={kindergartenData.groups} />
          </div>
        </Tab.Pane>
        <Tab.Pane eventKey="team">
          <div className="documents-content">
            <TeamPublic kgId={kindergartenData._id} />
          </div>
        </Tab.Pane>
        <Tab.Pane eventKey="news">
          <div className="documents-content">
            <NewsPublic scope="kg" kgId={kindergartenData._id} />
          </div>
        </Tab.Pane>



        <Tab.Pane eventKey="documents_pdf">
          <KindergartensDocsTabs docs={docs} types={typesDocs}/>
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
    </>
  );
};

export default KindergartenMainInfo;